<template>
  <div class="page-wrap" v-loading="loading">
    <el-row>
      <el-col :xs="24" :sm="20" :lg="12" :xl="14">
        <el-form
            ref="formRef"
            :model="initiative"
            :rules="rules"
            label-position="top"
            hide-required-asterisk
        >
          <el-row :gutter="10">
            <!-- Tashabbus tavsifi -->
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" v-if="!isModerator">
              <el-form-item label="Tashabbus tavsifi" prop="description">
                <el-input
                    size="large"
                    type="textarea"
                    v-model="initiative.description"
                    class="form-input"
                />
              </el-form-item>
            </el-col>

            <!-- Moderator kommenti -->
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" v-if="!isModerator">
              <el-form-item label="Moderator kommenti" prop="moderator_comment">
                <el-input
                    size="large"
                    type="textarea"
                    v-model="initiative.moderator_comment"
                    class="form-input"
                />
              </el-form-item>
            </el-col>

            <!-- So'ralgan mablag' -->
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" v-if="!isModerator">
              <el-form-item label="So'ralgan mablag'" prop="requested_amount">
                <el-input
                    size="large"
                    v-model="initiative.requested_amount"
                    v-money="money"
                    type="text"
                    class="form-input"
                />
              </el-form-item>
            </el-col>

            <!-- Tasdiqlangan mablag' -->
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" v-if="!isModerator">
              <el-form-item label="Tasdiqlangan mablag'" prop="granted_amount">
                <el-input
                    size="large"
                    v-model="initiative.granted_amount"
                    v-money="money"
                    type="text"
                    class="form-input"
                />
              </el-form-item>
            </el-col>

            <!-- Kategoriya -->
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Tashabbus kategoriyasi" prop="category_id">
                <el-select v-model="initiative.category_id" @change="changeCategory" style="width: 100%">
                  <el-option
                      v-for="category in categories"
                      :key="category.id"
                      :value="category.id"
                      :label="category.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>

            <!-- Viloyat -->
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" v-if="!isModerator">
              <el-form-item label="Viloyat" prop="region_id">
                <el-select v-model="initiative.region_id" @change="onChangeRegion" style="width: 100%">
                  <el-option
                      v-for="region in regions"
                      :key="region.id"
                      :value="region.id"
                      :label="region.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>

            <!-- Tuman -->
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" v-if="!isModerator">
              <el-form-item label="Tuman" prop="district_id">
                <el-select v-model="initiative.district_id" @change="onChangeDistrict" style="width: 100%">
                  <el-option
                      v-for="district in districts"
                      :key="district.id"
                      :value="district.id"
                      :label="district.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>

            <!-- Mahalla -->
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Mahalla" prop="quarter_id">
                <el-select v-model="initiative.quarter_id" style="width: 100%">
                  <el-option
                      v-for="quarter in quarters"
                      :key="quarter.id"
                      :value="quarter.id"
                      :label="quarter.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>

            <!-- Bosqich -->
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" v-if="!isModerator">
              <el-form-item label="Bosqich" prop="stage">
                <el-select v-model="initiative.stage" style="width: 100%">
                  <el-option
                      v-for="stage in stages"
                      :key="stage"
                      :value="stage"
                      :label="stage"
                  />
                </el-select>
              </el-form-item>
            </el-col>

            <!-- Tashkilot nomi -->
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Tashkilot nomi" prop="organization_id" v-if="showOrganizationField">
                <el-select v-model="initiative.organization_id" style="width: 100%">
                  <el-option
                      v-for="item in organizationList"
                      :key="item.id"
                      :value="item.id"
                      :label="item.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>

            <!-- Tashabbus yo'nalishi -->
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" v-if="!isModerator">
              <el-form-item label="Tashabbus yo'nalishi" prop="type">
                <el-select v-model="initiative.type" style="width: 100%">
                  <el-option
                      v-for="item in types"
                      :key="item.id"
                      :value="item.id"
                      :label="item.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>

            <!-- Yuklash -->
            <el-col :xs="24">
              <el-form-item
                  label="Xarid qilinadigan tovarlar reestrini yuklang"
                  prop="purchased_goods_file"
                  v-if="initiative.type === 'EQUIPMENT'"
              >
                <el-upload
                    ref="uploadRef"
                    class="upload-demo"
                    :action="uploadUrl"
                    :headers="uploadHeader"
                    v-model:file-list="purchased_goods_files"
                    :multiple="false"
                    accept="application/pdf"
                    :limit="1"
                    :on-success="onSuccessUpload"
                    :on-error="onErrorUpload"
                >
                  <template #trigger>
                    <el-button style="width: 100%" type="primary">
                      Xarid qilinadigan tovarlar reestri
                    </el-button>
                  </template>
                </el-upload>
              </el-form-item>
            </el-col>

            <!-- Buttons -->
            <el-col :span="24">
              <el-form-item>
                <el-button class="custom-btn" @click="() => $router.go(-1)">Orqaga</el-button>
                <el-button class="custom-btn" type="primary" @click="onSubmit">Saqlash</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { ElNotification } from "element-plus";

export default {
  name: "InitiativeForm",
  data() {
    return {
      loading: false,
      initiativeId: null,
      isModerator: false,
      initiative: {
        description: null,
        requested_amount: null,
        granted_amount: null,
        moderator_comment: null,
        region_id: null,
        organization_id: null,
        district_id: null,
        quarter_id: null,
        category_id: null,
        stage: null,
        type: null,
        purchased_goods_file: null,
      },
      organizationList: [],
      showOrganizationField: false,
      types: [
        { id: "CONSTRUCTION", title: "Qurilish" },
        { id: "EQUIPMENT", title: "Xarid qilish" },
      ],
      districts: [],
      regions: [],
      quarters: [],
      categories: [],
      stages: ["INITIAL", "PASSED", "NOT_PASSED"],
      purchased_goods_files: [],
      uploadUrl: `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`,
      uploadHeader: { Authorization: `${localStorage.getItem("accessToken")}` },
      money: { decimal: ".", thousands: " ", prefix: "", suffix: "", precision: 0 },
    };
  },
  computed: {
    rules() {
      return {
        description: [{ required: true, message: "Majburiy maydon", trigger: "blur" }],
        region_id: [{ required: true, message: "Majburiy maydon", trigger: "change" }],
        district_id: [{ required: true, message: "Majburiy maydon", trigger: "change" }],
        quarter_id: [{ required: true, message: "Majburiy maydon", trigger: "change" }],
        category_id: [{ required: true, message: "Majburiy maydon", trigger: "change" }],
        type: [{ required: false, message: "Majburiy maydon", trigger: "change" }],
        purchased_goods_file: [{ required: true, message: "Majburiy maydon", trigger: "change" }],
        organization_id: [{ required: true, message: "Majburiy maydon", trigger: "change" }],
        requested_amount: [{ validator: this.amountValidate, trigger: "blur" }],
        granted_amount: [{ validator: this.grantedAmountValidate, trigger: "blur" }],
      };
    },
  },
  methods: {
    // Validatorlar
    amountValidate(rule, value, callback) {
      const val = parseFloat((value || "").toString().replace(/\s/g, ""));
      if (!val || val <= 0) {
        callback(new Error("Qiymat 0 dan katta bo'lishi kerak"));
      } else if (val > 15000000000) {
        callback(new Error("Qiymat 15 000 000 000 dan kichik bo'lishi kerak"));
      } else if (
          this.initiative.type === "EQUIPMENT" &&
          val > this.initiative.board?.equipment_initiatives_max_amount
      ) {
        callback(
            new Error(
                `Ma'qullangan mablag' ${this.getPriceFormat(
                    this.initiative.board.equipment_initiatives_max_amount
                )} so'mdan oshib ketti`
            )
        );
      } else if (
          this.initiative.type === "CONSTRUCTION" &&
          val > this.initiative.board?.initiatives_max_amount
      ) {
        callback(
            new Error(
                `Ma'qullangan mablag' ${this.getPriceFormat(
                    this.initiative.board.initiatives_max_amount
                )} so'mdan oshib ketti`
            )
        );
      } else {
        callback();
      }
    },
    grantedAmountValidate(rule, value, callback) {
      const val = parseFloat((value || "").toString().replace(/\s/g, ""));
      if (val > 1500000000) {
        callback(new Error("Qiymat 1 500 000 000 dan kichik bo'lishi kerak"));
      } else if (
          this.initiative.type === "EQUIPMENT" &&
          val > this.initiative.board?.equipment_initiatives_max_amount
      ) {
        callback(
            new Error(
                `Ma'qullangan mablag' ${this.getPriceFormat(
                    this.initiative.board.equipment_initiatives_max_amount
                )} so'mdan oshib ketti`
            )
        );
      } else if (
          this.initiative.type === "CONSTRUCTION" &&
          val > this.initiative.board?.initiatives_max_amount
      ) {
        callback(
            new Error(
                `Ma'qullangan mablag' ${this.getPriceFormat(
                    this.initiative.board.initiatives_max_amount
                )} so'mdan oshib ketti`
            )
        );
      } else {
        callback();
      }
    },

    getPriceFormat(price) {
      return new Intl.NumberFormat("ru-RU").format(price).replace(/,/g, ",");
    },

    onSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;

        this.loading = true;
        const formData = {
          ...this.initiative,
          requested_amount: parseFloat(this.initiative.requested_amount.replace(/\s/g, "")),
          granted_amount: parseFloat(this.initiative.granted_amount.replace(/\s/g, "")),
        };

        const request = this.isModerator
            ? this.$http.put(`api/v1/moderators/initiatives/${this.initiative.public_id}`, formData)
            : this.$http.patch(`api/v1/initiatives/${this.initiative.public_id}`, formData);

        request
            .then(() => {
              ElNotification({ title: "Tabriklaymiz", message: "Muvaffaqiyatli saqlandi", type: "success" });
              this.$router.go(-1);
            })
            .catch(({ response }) => {
              ElNotification({ title: "Xatolik", message: response.data.message, type: "error" });
            })
            .finally(() => (this.loading = false));
      });
    },

    // Upload
    onSuccessUpload(res) {
      this.initiative.purchased_goods_file = res.hashId;
    },
    onErrorUpload(error) {
      ElNotification.error({
        message: JSON.parse(error?.message)?.message || "Yuklashda xatolik sodir bo'ldi",
      });
      this.loading = false;
    },

    // Region / District / Quarter
    onChangeRegion() {
      this.districts = [];
      this.initiative.district_id = null;
      this.quarters = [];
      this.initiative.quarter_id = null;
      this.getDistricts();
    },
    onChangeDistrict() {
      this.quarters = [];
      this.initiative.quarter_id = null;
      this.getQuarters();
    },

    // Category
    changeCategory(e) {
      this.getOrganizations(this.initiative.district_id, e);
    },

    getOrganizations(district_id, category_id) {
      const selectedOption = this.categories.find((cat) => cat.id === category_id);
      this.showOrganizationField = !!selectedOption?.organization_type;
      if (!this.showOrganizationField) this.initiative.organization_id = null;

      if (!this.showOrganizationField) return;

      this.loading = true;
      this.$http
          .get(
              `api/v1/organizations?district_id=${district_id}&organization_type=${selectedOption.organization_type}`
          )
          .then((res) => {
            this.organizationList = res.data?.organizations || [];
          })
          .finally(() => (this.loading = false));
    },

    // Fetch functions
    getCategories() {
      this.$http.get("api/v1/initiative-categories").then(({ data }) => {
        this.categories = data.initiative_categories;
      });
    },
    getRegions() {
      this.$http.get("api/v1/regions").then(({ data }) => (this.regions = data.regions));
    },
    getDistricts() {
      this.$http
          .get("api/v1/districts", { params: { region_id: this.initiative.region_id } })
          .then(({ data }) => (this.districts = data.districts));
    },
    getQuarters() {
      this.$http
          .get(`api/v1/quarters?district_id=${this.initiative.district_id}`)
          .then(({ data }) => (this.quarters = data.quarters));
    },
    getInitiative() {
      this.loading = true;
      this.$http
          .get(`api/v1/initiatives/${this.initiativeId}`)
          .then(({ data }) => {
            this.initiative = data;
            this.initiative.granted_amount = String(this.initiative.granted_amount);
            this.initiative.requested_amount = String(this.initiative.requested_amount);
            this.getRegions();
            this.getDistricts();
            this.getQuarters();
          })
          .finally(() => (this.loading = false));
    },
  },

  mounted() {
    if (this.$route.params.id) {
      this.initiativeId = this.$route.params.id;
      this.getInitiative();
    }
    if (this.$route.query.isModerator) this.isModerator = true;
    this.getCategories();
  },
};
</script>

<style scoped>
.page-wrap {
  padding: 10px;
}
</style>
